import React from 'react';
import cn from 'classnames';
import * as PropTypes from 'prop-types';

import Icon from '../../../Icon';
import styles from './styles.styl';
import { ConnectionShape } from '../../../../redux/opentok/helpers/shapes';
import { COLORS } from '../../../../constants/styles';

function PatientControls({ onPin, pinnedId, connection: { id } = {} }) {
  const pinned = pinnedId === id;
  const pinIcon = !pinned ? 'pin' : 'unpin';

  const handlePinToggle = e => {
    e.stopPropagation();
    onPin({ id });
  };

  return (
    <div className={styles.root}>
      <div className={styles.overlay} />
      <div
        className={cn(styles.actions, styles.patient, {
          [styles.pinned]: pinned,
        })}
      >
        <button onClick={handlePinToggle} className={styles.btn} type="button">
          <Icon name={pinIcon} size={24} style={{ fill: COLORS.white }} />
        </button>
      </div>
    </div>
  );
}

PatientControls.propTypes = {
  connection: ConnectionShape,
  pinnedId: PropTypes.string,
  onPin: PropTypes.func,
};

export default PatientControls;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/SubscriberBtns/PatientControls.jsx